export default __webpack_public_path__ + "static/media/beach-bg.d8260d21.jpg";